import { Stack, Typography } from '@mui/material';
import { FC, memo, useMemo } from 'react';
import { RotaPopUpDatePicker } from '../../components/DatePicker';
import { SelectType } from '../../components/selectType';
import { BluTitle } from '@bludata/components';
import { useWatch } from 'react-hook-form';
import { ContextMenu } from '../../components/ContextMenu';

interface ShiftInterface {
  turniType: 'pointOfSale' | 'user';
  date: Date;
  isFollowingPointOfSaleCalendar: boolean;
}

export const Shift: FC<ShiftInterface> = memo(
  ({ turniType, date, isFollowingPointOfSaleCalendar }) => {
    const type = useWatch({
      name: `typeShift`,
    });
    const GetContent = useMemo(() => {
      return (
        <Stack flex="1" gap={1}>
          <Stack>
            <Typography>Primo turno</Typography>
            <Stack direction="row" gap={1}>
              <RotaPopUpDatePicker
                name="startTime1"
                calendarType="Shift"
                errorProperty="firstTurnShift"
                date={date}
                disable={isFollowingPointOfSaleCalendar}
              />
              <RotaPopUpDatePicker
                name="endTime1"
                calendarType="Shift"
                errorProperty="firstTurnShift"
                date={date}
                disable={isFollowingPointOfSaleCalendar}
              />
            </Stack>
          </Stack>

          <Stack>
            <Typography>Secondo turno</Typography>
            <Stack direction="row" gap={1}>
              <RotaPopUpDatePicker
                name="startTime2"
                calendarType="Shift"
                errorProperty="secondTurnShift"
                date={date}
                disable={isFollowingPointOfSaleCalendar}
              />
              <RotaPopUpDatePicker
                name="endTime2"
                calendarType="Shift"
                errorProperty="secondTurnShift"
                date={date}
                disable={isFollowingPointOfSaleCalendar}
              />
            </Stack>
          </Stack>
        </Stack>
      );
    }, [date, isFollowingPointOfSaleCalendar]);

    return (
      <Stack flex="1" gap={1}>
        {type !== 'closed' && type !== 'extra-closed' && (
          <>
            <Stack direction="row" flex="1" gap={1} alignItems="center">
              <Stack flex="1">
                <BluTitle text="Turno di lavoro" />
              </Stack>

              <ContextMenu
                calendarType="Shift"
                disabled={isFollowingPointOfSaleCalendar}
              />
            </Stack>
            {/* <SelectType calendarType="Shift" turniType={turniType} /> */}

            <Stack>{GetContent}</Stack>
          </>
        )}
      </Stack>
    );
  }
);
